__turbopack_context__.v({
  "bold": "JGGP7a_bold",
  "buttonContainer": "JGGP7a_buttonContainer",
  "columns": "JGGP7a_columns",
  "container": "JGGP7a_container",
  "label": "JGGP7a_label",
  "notes": "JGGP7a_notes",
  "rows": "JGGP7a_rows",
});
